//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey } from '@/tools'
export default {
  props: {
    question: {
      type: Object,
      default: () => {
        return {
          v_ownId: OWNID,
          v_active: false,
          v_label: '段落说明',
          type: 'section',
          displayIndex: false,
          title: '请填写说明，例如：第一部分',
          backgroundColor: '#fff7ee',
          backgroundOpacity: 100,
          logic: {
            blocks: {
              typeBlock: 'all',
              list: [],
            },
          },
        }
      },
    },
  },
  components: {},
  data() {
    return {
      editorOption: {
        modules: { toolbar: [] },
        placeholder:'请输入'
      },
      curItem: null,
      type: null,
      curQuestion: {},
    }
  },
  computed: {
    editor() {
      return this.$refs['section-title'].quill
    },
  },
  mounted() {
    let editor = this.editor
    if (editor) {
      this.$nextTick(() => {
        let len = editor.getLength()
        editor.setSelection(len)
      })
    }
  },
  // mounted() {
  //   let radioTitle = this.$refs['section-title']
  //   if (radioTitle) {
  //     radioTitle.$refs['$textarea'].focus()
  //   }
  // },
  watch: {
    question: {
      handler(newV) {
        this.curQuestion = { ...newV }
      },
      immediate: true,
    },
  },
  methods: {
    blurInput() {
      if (!this.curQuestion.title) {
        this.curQuestion.title = this.question.title
      } else {
        this.question.title = this.curQuestion.title
      }
    },
    onEditorChange(event) {
      event.quill.deleteText(500, 4)
    },
    getValue() {
      return this.curQuestion
    },
  },
}
